import { DialogContent } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import DateHelper from "core/DateHelper";
import { EditIcon } from "core/Icons";
import PropTypes, { bool, func } from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericAlert, GenericDateInput, GenericDialog, GenericDialogActions, GenericExpansionPanel, GenericGrid, GenericNumberInput, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import GridButton from "views/Components/GridButton";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";
import { GridColumnType, ProgramCodes, WireMsbStatusValue } from "views/Constants/Constant";
import BeneficiaryDetail from "views/WireTransfer/CreateWireTransfer/BeneficiaryDetail";

class MSBSubTransactionsDetail extends Component {
	constructor(props) {
		super(props);

		this.InitialModel = {
			FromDate: DateHelper.GetDate(),
			ToDate: DateHelper.GetDate(),
			StatusId: null,
			FileName: null,
			ClientId: null,
			MainTransactionId: null
		};

		this.columns = [
			{
				Header: "File Name",
				accessor: "FileName"
			},
			{
				Header: "Status",
				accessor: "MsbStatusDesc"
			},
			{
				Header: "MainTransactionId",
				accessor: "MainTransactionId"
			},
			{
				Header: "Sub-TransactionId",
				accessor: "WireTransferMSBFileDetail.Id"
			},
			{
				Header: "Client Tranaction Id",
				accessor: "WireTransferMSBFileDetail.RefNo"
			},
			{
				Header: "Message Type",
				accessor: "MessageType"
			},
			{
				Header: "Client Name",
				accessor: "ClientName"
			},

			{
				Header: "Date of Request",
				accessor: "DateOfRequest",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Value Effective",
				accessor: "ValueEffective",
				type: GridColumnType.DateTimeUtc
			},
			{
				Header: "Sender Name",
				accessor: "WireTransferMSBFileDetail.SenderName"
			},
			{
				Header: "BeneficiaryName",
				accessor: "WireTransferMSBFileDetail.BeneficiaryName"
			},
			{
				Header: "Amount",
				accessor: "WireTransferMSBFileDetail.BaseAmount",
				type: GridColumnType.Money,
				ColumnType: GridColumnType.Money
			},
			{
				Header: "Currency",
				accessor: "Currency"
			},
			{
				Header: "Sending Country",
				accessor: "SendingCountry"
			},
			{
				Header: "Destination Country",
				accessor: "DestinationCountry"
			},

		];

		this.detailColumns = [

			{
				Header: "Settlement Direction",
				accessor: "WireTransferMSBFileDetail.Direction"
			},
			{
				Header: "Payment Amount",
				accessor: "WireTransferMSBFileDetail.OriginalAmount"
			},
			{
				Header: "Settlement Amount",
				accessor: "WireTransferMSBFileDetail.SettlementAmount"
			},
			{
				Header: "Settlement Route",
				accessor: "WireTransferMSBFileDetail.SettlementRoute"
			},
			{
				Header: "Settlement Transit",
				accessor: "WireTransferMSBFileDetail.SettlementTransit"
			},
			{
				Header: "OrderingInstIdentifier",
				accessor: "WireTransferMSBFileDetail.OrderingInstIdentifier"
			},
			{
				Header: "Originator Route",
				accessor: "WireTransferMSBFileDetail.OriginatorRoute"
			},
			{
				Header: "Originator Transit",
				accessor: "WireTransferMSBFileDetail.OriginatorTransit"
			},
			{
				Header: "Settlement Transit",
				accessor: "WireTransferMSBFileDetail.SettlementTransit"
			},
			{
				Header: "Ordering Inst. Name",
				accessor: "WireTransferMSBFileDetail.OrderingInstName"
			},
			{
				Header: "Ordering Institution Addr1",
				accessor: "WireTransferMSBFileDetail.OrderingInstitutionAddr1"
			},
			{
				Header: "Ordering Institution Addr2",
				accessor: "WireTransferMSBFileDetail.OrderingInstitutionAddr2"
			},
			{
				Header: "Ordering Institution Addr3",
				accessor: "WireTransferMSBFileDetail.OrderingInstitutionAddr3"
			},
			{
				Header: "Contact Name",
				accessor: "WireTransferMSBFileDetail.ContactName"
			},
			{
				Header: "Deliver To",
				accessor: "WireTransferMSBFileDetail.DeliverTo"
			},
			{
				Header: "Receiver BIC",
				accessor: "WireTransferMSBFileDetail.ReceiverBIC"
			},
			{
				Header: "Dest Branch Identifier",
				accessor: "WireTransferMSBFileDetail.DestBranchIdentifier"
			},
			{
				Header: "Destination Route",
				accessor: "WireTransferMSBFileDetail.DestinationRoute"
			},
			{
				Header: "Contact Name",
				accessor: "WireTransferMSBFileDetail.ContactName"
			},
			{
				Header: "Deliver To",
				accessor: "WireTransferMSBFileDetail.DeliverTo"
			},
			{
				Header: "Receiver BIC",
				accessor: "WireTransferMSBFileDetail.ReceiverBIC"
			},
			{
				Header: "Dest Branch Identifier",
				accessor: "WireTransferMSBFileDetail.DestBranchIdentifier"
			},
			{
				Header: "Destination Route",
				accessor: "WireTransferMSBFileDetail.DestinationRoute"
			},
			{
				Header: "Destination Route",
				accessor: "WireTransferMSBFileDetail.DestinationRoute"
			},
			{
				Header: "Destination Transit",
				accessor: "WireTransferMSBFileDetail.DestinationTransit"
			},
			{
				Header: "Dest. Branch Name",
				accessor: "WireTransferMSBFileDetail.DestBranchName"
			},
			{
				Header: "Dest. Branch Addr1",
				accessor: "WireTransferMSBFileDetail.DestBranchAddr1"
			},
			{
				Header: "Dest. Branch Addr2",
				accessor: "WireTransferMSBFileDetail.DestBranchAddr2"
			},
			{
				Header: "Dest. Branch Addr3",
				accessor: "WireTransferMSBFileDetail.DestBranchAddr3"
			},
			{
				Header: "Dest Country",
				accessor: "WireTransferMSBFileDetail.DestCountry"
			},
			{
				Header: "Rec Corresondent Name",
				accessor: "WireTransferMSBFileDetail.RecCorresondentName"
			},
			{
				Header: "Rec Corresondent Identifier",
				accessor: "WireTransferMSBFileDetail.RecCorresondentIdentifier"
			},
			{
				Header: "Rec Corresondent Addr1",
				accessor: "WireTransferMSBFileDetail.RecCorresondentAddr1"
			},
			{
				Header: "Rec Corresondent Addr2",
				accessor: "WireTransferMSBFileDetail.RecCorresondentAddr2"
			},
			{
				Header: "Rec Corresondent Addr3",
				accessor: "WireTransferMSBFileDetail.RecCorresondentAddr3"
			},
			{
				Header: "Intermediary Name",
				accessor: "WireTransferMSBFileDetail.IntermediaryName"
			},
			{
				Header: "Intermediary Addr1",
				accessor: "WireTransferMSBFileDetail.IntermediaryAddr1"
			},
			{
				Header: "Intermediary Addr2",
				accessor: "WireTransferMSBFileDetail.IntermediaryAddr2"
			},
			{
				Header: "IntermediaryAddr3",
				accessor: "WireTransferMSBFileDetail.IntermediaryAddr3"
			},
			{
				Header: "Branch Buy",
				accessor: "WireTransferMSBFileDetail.BranchBuy"
			},
			{
				Header: "Rate Special Rate",
				accessor: "WireTransferMSBFileDetail.RateSpecialRate"
			},
			{
				Header: "Exchange Rate Date",
				accessor: "WireTransferMSBFileDetail.ExchangeRateDate",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Payment Method",
				accessor: "WireTransferMSBFileDetail.PaymentMethod"
			},
			{
				Header: "Rate Special Rate",
				accessor: "WireTransferMSBFileDetail.RateSpecialRate"
			},
			{
				Header: "Exchange Rate Date",
				accessor: "WireTransferMSBFileDetail.ExchangeRateDate",
				type: GridColumnType.DateUtc
			},

			{
				Header: "Branch Sell Rate",
				accessor: "WireTransferMSBFileDetail.BranchSellRate"
			},

			{
				Header: "Payment Method",
				accessor: "WireTransferMSBFileDetail.PaymentMethod"
			},

			{
				Header: "Sender Type",
				accessor: "WireTransferMSBFileDetail.SenderType"
			},
			{
				Header: "Sender Addr1",
				accessor: "WireTransferMSBFileDetail.SenderAddr1"
			},
			{
				Header: "Sender Addr2",
				accessor: "WireTransferMSBFileDetail.SenderAddr2"
			},
			{
				Header: "Sender Addr3",
				accessor: "WireTransferMSBFileDetail.SenderAddr3"
			},
			{
				Header: "Id Country",
				accessor: "WireTransferMSBFileDetail.IdCountry"
			},
			{
				Header: "Id Sender",
				accessor: "WireTransferMSBFileDetail.IdSender"
			},
			{
				Header: "Id Issuer",
				accessor: "WireTransferMSBFileDetail.IdIssuer"
			},
			{
				Header: "Sender Phone No",
				accessor: "WireTransferMSBFileDetail.SenderPhoneNo"
			},
			{
				Header: "Principle Natureof Business",
				accessor: "WireTransferMSBFileDetail.PrincipleNatureofBusiness"
			},
			{
				Header: "Sender Birth Date",
				accessor: "WireTransferMSBFileDetail.SenderBirthDate",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Company Representative",
				accessor: "WireTransferMSBFileDetail.CompanyRepresentative"
			},
			{
				Header: "Reason For Transfer",
				accessor: "WireTransferMSBFileDetail.ReasonForTransfer"
			},
			{
				Header: "Additional Sender Info",
				accessor: "WireTransferMSBFileDetail.AdditionalSenderInfo"
			},
			{
				Header: "Beneficiary Addr1",
				accessor: "WireTransferMSBFileDetail.BeneficiaryAddr1"
			},
			{
				Header: "Beneficiary Addr2",
				accessor: "WireTransferMSBFileDetail.BeneficiaryAddr2"
			},
			{
				Header: "Beneficiary Addr3",
				accessor: "WireTransferMSBFileDetail.BeneficiaryAddr3"
			},
			{
				Header: "Recipient Information",
				accessor: "WireTransferMSBFileDetail.RecipientInformation"
			},
			{
				Header: "Special Instructions",
				accessor: "WireTransferMSBFileDetail.SpecialInstructions"
			},
			{
				Header: "Internal Notes",
				accessor: "WireTransferMSBFileDetail.InternalNotes"
			},
			{
				Header: "Additional SWIFT Information",
				accessor: "WireTransferMSBFileDetail.AdditionalSWIFTInformation"
			},
			{
				Header: "Member Service Charge",
				accessor: "WireTransferMSBFileDetail.MemberServiceCharge"
			},
			{
				Header: "Billing Code",
				accessor: "WireTransferMSBFileDetail.BillingCode"
			},
			{
				Header: "Billing System",
				accessor: "WireTransferMSBFileDetail.BillingSystem"
			},
			{
				Header: "NON Negotiable",
				accessor: "WireTransferMSBFileDetail.NONNegotiable"
			},
			{
				Header: "Created By",
				accessor: "WireTransferMSBFileDetail.CreatedBy"
			},
			{
				Header: "Created Date",
				accessor: "WireTransferMSBFileDetail.CreatedDate",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Date Last Modified",
				accessor: "WireTransferMSBFileDetail.DateLastModified"
			},
			{
				Header: "Last Modified By",
				accessor: "WireTransferMSBFileDetail.LastModifiedBy"
			},
			{
				Header: "WireStatus",
				accessor: "WireTransferMSBFileDetail.WireStatus"
			},
			{
				Header: "Beneficiary Birth Date",
				accessor: "WireTransferMSBFileDetail.BeneficiaryBirthDate",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Receiving Institution",
				accessor: "WireTransferMSBFileDetail.ReceivingInstitution"
			},
			{
				Header: "Beneficiary Company Name",
				accessor: "CompanyName"
			},
			{
				Header: "Country",
				accessor: "CountryFormat"
			}

		];

		this.renderColumns = [{
			Header: "Actions",
			sortable: false,
			filterable: false,
			width: 80,
			Cell: row => (
				<div>

					<GridButton
						tooltip="Msb Edit"
						Disabled={!row.original.IsEditable}
						OnClick={() => this.HandleOpenEdit(row.original.WireTransferMSBFileDetail.Id)}
						Icon={EditIcon}
					/>
				</div>
			)
		},

		... this.columns,
		...this.detailColumns];

		this.defaultHeader = { TotalTransactionAmount: null, SubTransactionsTotal: null, MainTransactionAmount: null };
		this.state = {
			model: { ...this.InitialModel },
			headerModel: { ... this.defaultHeader },
			subStatusList: [],
			tempSubStatusList: [],
			transactionList: [],
			PendingList: [],
			NonPendingList: [],
			isLoading: false,
			ShowFileDetail: false,
			FileDetail: [],
			approvalTransactionList: [],
			approvalDialog: false,
			detailDialog: false,
			ApprovalModel: {},
			templateDetailModel: {}
		};


		this.subTransactionColumns = [
			...this.columns,
			...this.detailColumns
		]
	}

	componentDidMount() {
		this.props.setAppLeftTitle("MSB Sub Details");
		this.props.setAppCenterTitle("CLEARING & SETTLEMENT");
	}

	handleChange = (name, newValue) => {
		this.setState(function (state) {
			var model = state.model || {};
			model[name] = newValue;
			return { model };
		});
	}



	GetData = () => {
		this.showLoading();

		this.setState({
			transactionList: [],
			headerModel: { TotalTransactionAmount: null, SubTransactionsTotal: null, MainTransactionAmount: null }
		}, () => {
			Proxy.POST(
				"/bankapi/v1.0/ClearingSettlement/GetMSBSubTransactionsDetail",
				this.state.model,
				responseData => {
					if (!responseData.IsSucceeded)
						this.showBasicAlert("Error", "Send operation error : " + responseData.ErrorDescription + "!!!", "error");
					else {
						var transactionList = [];


						var headerModel = { ... this.defaultHeader };
						var PendingList = [];
						var NonPendingList = [];
						if (responseData.Item != null &&
							responseData.Item.DetailList != null &&
							responseData.Item.DetailList.length != 0) {
							transactionList = responseData.Item.DetailList;
							headerModel = responseData.Item.TransactionInfo;
							PendingList = transactionList.filter(i => i.MsbStatusValue == WireMsbStatusValue.Pending);
							NonPendingList = transactionList.filter(i => i.MsbStatusValue != WireMsbStatusValue.Pending);
						}
						this.setState({
							transactionList, PendingList: PendingList, NonPendingList: NonPendingList, headerModel, isLoading: false
						});
					}
				},
				error => {
					this.showBasicAlert("Error", "An error occurred during the api visit" + error, "error");
				}
			);
		});
	}

	HandleDelete = () => {

	}

	showBasicAlert = (title, message, type) => {
		this.setState({ isLoading: false, alert: <GenericAlert Title={title} Message={message} Type={type} ShowCancel={false} OnConfirm={() => this.hideAlert()} /> });
	}

	showLoading = () => { this.setState({ alert: null, isLoading: true }); }
	hideLoading = () => { this.setState({ alert: null, isLoading: false }); }
	hideAlert = () => { this.setState({ alert: null, isLoading: false }); }

	ClearModel = () => {
		this.setState({
			model: { ...this.InitialModel },
			ShowFileDetail: false,
			FileDetail: []
		});
	}

	HandleOpenDetail = (index) => {
		const approveModel = this.state.transactionList[index].WireTransferMSBFileDetail;
		this.setState({ isLoading: true });
		Proxy.POST(
			"/bankapi/v1.0/WireTransfer/MsbShowSubDetail",
			{ Id: approveModel.Id },
			(responseData) => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					this.CloseDialog();

					return;
				}
				if (responseData.Item !== null) {

					this.setState({ approvalDialog: false, ShowFileDetail: true, ApprovalModel: responseData.Item });
				}
			},
			(error) => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			}
		);


	}
	HandleOpenEdit = (Id) => {
		const templateDetailModel = this.state.transactionList.find(x => x.WireTransferMSBFileDetail.Id == Id).WireBeneficiaryTemplate;
		this.setState({ isLoading: true });
		Proxy.POST(
			"/bankapi/v1.0/WireTransfer/MsbShowSubDetail",
			{ Id: Id },
			(responseData) => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					this.CloseDialog();

					return;
				}
				if (responseData.Item !== null) {

					this.setState({ approvalDialog: true, ShowFileDetail: true, ApprovalModel: responseData.Item, templateDetailModel });
				}
			},
			(error) => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			}
		);
	}
	HandleClose = () => {
		this.CloseDialog();
	}

	HandleRejectStatus = () => {
		if (!this.state.approvalDialog)
			return;
		var model = this.state.ApprovalModel;
		var transactionRequest = {
			StatusType: WireMsbStatusValue.Reject,
			FileId: model.FileId,
			Id: model.Id
		};
		Proxy.POST(
			"/bankapi/v1.0/WireTransfer/MsbSubDetailStatusChange",
			transactionRequest,
			(responseData) => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					return;
				}
				if (responseData.Item !== null) {
					this.CloseDialog();
					this.GetData();
				}
			},
			(error) => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			}
		);

	}

	HandleApproveStatus = () => {
		if (!this.state.approvalDialog)
			return;
		var model = this.state.ApprovalModel;
		var transactionRequest = {
			StatusType: WireMsbStatusValue.Approve,
			FileId: model.FileId,
			Id: model.Id
		};
		Proxy.POST(
			"/bankapi/v1.0/WireTransfer/MsbSubDetailStatusChange",
			transactionRequest,
			(responseData) => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					return;
				}
				if (responseData.Item !== null) {
					this.CloseDialog();
					this.GetData();
				}
			},
			(error) => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			}
		);

	}
	CloseDialog = () => {
		this.setState({ detailDialog: false, approvalDialog: false, ShowFileDetail: false });
	}


	render() {
		const { Disabled } = this.props;
		const { model, headerModel, isLoading, PendingList, NonPendingList, ShowFileDetail, templateDetailModel, ApprovalModel, approvalDialog } = this.state;

		const showSummary = headerModel.SubTransactionsTotal || headerModel.MainTransactionAmount || headerModel.TotalTransactionAmount;
		return (
			<div>
				<LoadingComponent Show={isLoading} />

				{this.state.alert}
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.GetData, Disabled: Disabled },
					{ Code: "Delete", OnClick: this.HandleDelete, Disabled: Disabled },
					{ Code: "Clear", OnClick: this.ClearModel, Disabled: Disabled }
				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />
				<Card>

					<GenericExpansionPanel Title={"Filter Panel"}>
						<CardBody>
							<GridContainer>
								<GridItem xs={3}>
									<GenericSelectInput
										Name="ClientId"
										LabelText="Client"
										Method="POST"
										Url="/bankapi/v1.0/BankCustomer/Search"
										Parameter={{}}
										DataRoot="Item"
										KeyValueMember="Id"
										RenderItem={d => `${d.UniqueClientId} - ${d.Name}`}
										Value={model.ClientId || ""}
										ValueChanged={this.handleChange}
										CanClear />
									<GenericDateInput
										Name="FromDate"
										LabelText="From Date"
										Utc={true}
										Value={model.FromDate == null || undefined ? "" : model.FromDate}
										ValueChanged={this.handleChange}
										MaxDate={DateHelper.GetDate()}
										IncludeTime={false} />
									<GenericDateInput
										Name="ToDate"
										LabelText="To Date"
										Utc={true}
										Value={model.ToDate == null || undefined ? "" : model.ToDate}
										ValueChanged={this.handleChange}
										MaxDate={DateHelper.GetDate()}
										IncludeTime={false} />

								</GridItem>
								<GridItem xs={3}>
									<GenericNumberInput
										Name="MainTransactionId"
										LabelText="Main Transaction ID"
										Value={model.MainTransactionId == null ? "" : model.MainTransactionId}
										ValueChanged={this.handleChange}
										NoFormatting={true} />

									<GenericTextInput
										Name="FileName"
										LabelText="File Name"
										Value={model.FileName}
										ValueChanged={this.handleChange}
									/>
									<ParameterComponent
										Name="StatusId"
										Value={model.StatusId}
										LabelText="Status Type"
										ParameterCode="WireMsbStatus"
										ValueChanged={this.handleChange}
										Disabled={Disabled} />
								</GridItem>

								<GridItem xs={3}>

								</GridItem>

								<GridItem xs={3}>
									{showSummary &&
										<Card>
											<CardBody>
												{headerModel.MainTransactionAmount &&
													<GenericNumberInput
														LabelText="Main Transaction Amount"
														LabelMd={8}
														Value={headerModel.MainTransactionAmount}
														Prefix="$"
														Disabled={true} />
												}
												{headerModel.SubTransactionsTotal &&
													<GenericNumberInput
														LabelText="Sub-Transactions Total"
														LabelMd={8}
														Value={headerModel.SubTransactionsTotal}
														Prefix="$"
														Disabled={true} />
												}
												{headerModel.TotalTransactionAmount &&
													<GenericNumberInput
														LabelText="Sub-Transactions Total(CAD)"
														LabelMd={8}
														Value={headerModel.TotalTransactionAmount}
														Prefix="$"
														Disabled={true} />
												}
											</CardBody>
										</Card>
									}
								</GridItem>
								<br />
							</GridContainer>

						</CardBody>
					</GenericExpansionPanel>
				</Card>

				<Card className="no-radius">
					<CardBody>
						<CardHeader>
							<GenericTitle text={"BSO Approval List"} />
						</CardHeader>
						<GridItem xs={12}>
							<GridItem>
								<GenericGrid
									Data={PendingList}
									Sorted={[{ id: "DateRequest", desc: true }]}
									Columns={this.renderColumns}
									ProgramCode={ProgramCodes.Bank_Programs_Bank_Account}
									ShowPagination={true}

								/>
							</GridItem>
						</GridItem>
					</CardBody>
				</Card>

				<Card className="no-radius">
					<CardBody>
						<CardHeader>
							<GenericTitle text={"Sub-Transaction List"} />
						</CardHeader>
						<GridItem xs={12}>
							<GridItem>
								<GenericGrid
									Data={NonPendingList}
									Columns={this.subTransactionColumns}
									ProgramCode={ProgramCodes.Bank_Programs_Bank_Account}
									ShowPagination={true}
								/>
							</GridItem>
						</GridItem>
					</CardBody>
				</Card>

				<GenericDialog open={ShowFileDetail} maxWidth="lg">
					<DialogContent>
						<h4 style={{ color: "black", textAlign: "center" }}><b>Transaction Details</b></h4>
						<br />

						<BeneficiaryDetail
							CompanyName={templateDetailModel.CompanyName}
							Name={templateDetailModel.Name}
							MiddleName={templateDetailModel.MiddleName}
							LastName={templateDetailModel.LastName}
							AddressLine1={templateDetailModel.AddressLine1}
							AddressLine2={templateDetailModel.AddressLine2}
							ZipCode={templateDetailModel.ZipCode}
							CityId={templateDetailModel.CityId}
							ProvinceId={templateDetailModel.ProvinceId}
							CountryId={templateDetailModel.CountryId}
							IsDomestic={templateDetailModel.BankCountry != null && templateDetailModel.BankCountry.ISO2 == "CA"}
							BankCountryId={templateDetailModel.BankCountryId}
							BankFinInsId={templateDetailModel.BankFinInsId}
							BankName={templateDetailModel.BankName}
							BankBranchId={templateDetailModel.BankBranchId}
							BankTransitNumber={templateDetailModel.BankTransitNumber}
							AccountNumber={templateDetailModel.AccountNumber}
							BankSwiftCode={templateDetailModel.BankSwiftCode}
							BankAddressLine1={templateDetailModel.BankAddressLine1}
							BankAddressLine2={templateDetailModel.BankAddressLine2}
							BankZipCode={templateDetailModel.BankZipCode}
							BankCityId={templateDetailModel.BankCityId}
							BankProvinceId={templateDetailModel.BankProvinceId}
							BankInstitution={templateDetailModel.BankInstitution}
							Alias={templateDetailModel.Alias}
							Disabled={true} />
						<br />

						<GridContainer>
							<GridItem xs={4}>
								<GenericTextInput
									Name="SenderName"
									LabelText="Sender Name"
									Value={ApprovalModel.SenderName}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="SenderBirthDate"
									LabelText="Sender Birth Date"
									Value={ApprovalModel.SenderBirthDate}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="IdCountry"
									LabelText="Id Country"
									Value={ApprovalModel.IdCountry}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="SenderInternalBlackList"
									LabelText="Internal Black List"
									Value={ApprovalModel.SenderInternalBlackList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="SenderWacthList"
									LabelText="Watch List"
									Value={ApprovalModel.SenderWacthList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>
								<GenericTextInput
									Name="SenderLimit"
									LabelText="Limit Control"
									Value={ApprovalModel.SenderLimit}
									Disabled={true}
								/>
								{ApprovalModel.SenderLimitResult &&
									<GenericTextInput
										Name="SenderLimitResult"
										LabelText="Limit Result"
										Value={ApprovalModel.SenderLimitResult}
									/>
								}
							</GridItem>

							<GridItem xs={4}>
								<GenericTextInput
									Name="BeneficaryName"
									LabelText="Beneficiary Name"
									Value={ApprovalModel.BeneficaryName}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="BeneficaryBirthDate"
									LabelText="Beneficiary Birth Date"
									Value={ApprovalModel.BeneficaryBirthDate}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="DestCountry"
									LabelText="Dest Country"
									Value={ApprovalModel.DestCountry}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="BeneficiaryInternalBlackList"
									LabelText="Internal Black List"
									Value={ApprovalModel.BeneficiaryInternalBlackList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="BeneficaryWatchList"
									LabelText="Watch List"
									Value={ApprovalModel.BeneficaryWatchList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>
								<GenericTextInput
									Name="BeneficiaryLimit"
									LabelText="Limit Control"
									Value={ApprovalModel.BeneficiaryLimit}
									Disabled={true}
								/>
								{ApprovalModel.BeneficiaryLimitResult &&
									<GenericTextInput
										Name="BeneficiaryLimitResult"
										LabelText="Limit Result"
										Value={ApprovalModel.BeneficiaryLimitResult}
									/>
								}
							</GridItem>

							<GridItem xs={4}>

								<GenericTextInput
									Name="ReceivingInstitution"
									LabelText="Receiving Institution"
									Value={ApprovalModel.ReceivingInstitution}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="DestCountry"
									LabelText="Dest Country"
									Value={ApprovalModel.DestCountry}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="CorparateInternalBlackList"
									LabelText="Internal Black List"
									Value={ApprovalModel.CorparateInternalBlackList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

								<GenericTextInput
									Name="CorparateWatchList"
									LabelText="Watch List"
									Value={ApprovalModel.CorparateWatchList}
									ValueChanged={this.handleChange}
									Disabled={true}
								/>

							</GridItem>
						</GridContainer>
					</DialogContent>
					<GenericDialogActions>
						{approvalDialog &&
							<Button size="sm" onClick={this.HandleApproveStatus}>
								Approve
							</Button>
						}
						{approvalDialog &&
							<Button size="sm" onClick={this.HandleRejectStatus}>
								Reject
							</Button>
						}
						<Button size="sm" onClick={this.HandleClose}>
							Close
						</Button>
					</GenericDialogActions>
				</GenericDialog>
			</div>
		);
	}
}

MSBSubTransactionsDetail.propTypes = {
	classes: PropTypes.object,
	handleOperationType: func,
	showQuestionMessage: func,
	setAppLeftTitle: func,
	setAppCenterTitle: func,
	Disabled: bool
};

export default withArtifex(MSBSubTransactionsDetail, {});